import { useMemo } from 'react';

import { useAiAvailableConfigurationsQuery } from 'src/shared/graphql/generated';

export const useAvailableStyles = (
  orgId: number | undefined,
  spaceType: string | null | undefined = 'exterior',
): string[] => {
  const { data } = useAiAvailableConfigurationsQuery({
    variables: { spaceType, orgId },
  });

  return useMemo(() => data?.aiAvailableConfigurations?.styles ?? [], [data]);
};
